export const faqLinks = {
  contactUs: 'https://simcase-apps.omnidesk.ru/?send=question',
};
